import Icon from "@ant-design/icons/lib/components/Icon";
import {
  Button,
  Divider,
  Form,
  FormProps,
  Input,
  Popover,
  Radio,
  Space,
} from "antd";
import React, { useState } from "react";
import { DropDown } from "assets/icons";
import moment from "moment";
import styles from "./UserListFilter.module.scss";
import { CustomerLearningTimeStatisticsParams } from "../../../../../types/dto/request/reporting";
import DateInput from "../DateInput";

export interface UserListFilterProps {
  initialValues: CustomerLearningTimeStatisticsParams;
  onSubmit: (val: CustomerLearningTimeStatisticsParams) => void;
}

function UserListFilter({ initialValues, onSubmit }: UserListFilterProps) {
  const [form] = Form.useForm<CustomerLearningTimeStatisticsParams>();
  const [open, setOpen] = useState(false);

  function toggleFilterButton() {
    setOpen((prevState) => {
      form.resetFields();
      return !prevState;
    });
  }

  const handleSearch: FormProps<
    CustomerLearningTimeStatisticsParams
  >["onFinish"] = (values) => {
    onSubmit(values);
    toggleFilterButton();
  };

  const handleBlur = () => {
    const customerEmail = form.getFieldValue("customerEmail");
    const courseName = form.getFieldValue("courseName");
    const customerName = form.getFieldValue("customerName");
    const userStatus = form.getFieldValue("userStatus");
    form.setFieldsValue({
      ...form.getFieldsValue(),
      customerEmail: customerEmail && customerEmail.trim(),
      courseName: courseName && courseName.trim(),
      customerName: customerName && customerName.trim(),
      userStatus: userStatus && userStatus.trim(),
    });
  };

  const handleReset = () => {
    form.setFieldsValue({
      customerEmail: "",
      customerName: undefined,
      courseName: undefined,
      firstActivityDateFrom: undefined,
      firstActivityDateTo: undefined,
      lastActivityDateFrom: undefined,
      lastActivityDateTo: undefined,
      userStatus: undefined,
    });
  };

  const content = (
    <Form
      form={form}
      layout="inline"
      className={styles.searchForm}
      onFinish={handleSearch}
      initialValues={initialValues}
    >
      <Space direction="vertical" align="end" size={24}>
        <Form.Item label="First activity date">
          <Form.Item noStyle name="firstActivityDateFrom">
            <DateInput
              placeholder="Start date"
              disabledDate={(date: moment.Moment) =>
                date.startOf("day") > moment().startOf("day") ||
                (form.getFieldValue("firstActivityDateTo") &&
                  date > form.getFieldValue("firstActivityDateTo")) ||
                (form.getFieldValue("lastActivityDateFrom") &&
                  date > form.getFieldValue("lastActivityDateFrom"))
              }
            />
          </Form.Item>
          <span style={{ margin: "0 20px" }}>to</span>
          <Form.Item noStyle name="firstActivityDateTo">
            <DateInput
              placeholder="End date"
              disabledDate={(date: moment.Moment) =>
                date.valueOf() > moment().valueOf() ||
                (form.getFieldValue("firstActivityDateFrom") &&
                  date < form.getFieldValue("firstActivityDateFrom"))
              }
            />
          </Form.Item>
        </Form.Item>

        <Form.Item label="Last activity date">
          <Form.Item noStyle name="lastActivityDateFrom">
            <DateInput
              placeholder="Start date"
              disabledDate={(date: moment.Moment) =>
                date.startOf("day") > moment().startOf("day") ||
                (form.getFieldValue("lastActivityDateTo") &&
                  date > form.getFieldValue("lastActivityDateTo")) ||
                (form.getFieldValue("firstActivityDateFrom") &&
                  date < form.getFieldValue("firstActivityDateFrom"))
              }
            />
          </Form.Item>
          <span style={{ margin: "0 20px" }}>to</span>
          <Form.Item noStyle name="lastActivityDateTo">
            <DateInput
              placeholder="End date"
              disabledDate={(date: moment.Moment) =>
                date.valueOf() > moment().valueOf() ||
                (form.getFieldValue("lastActivityDateFrom") &&
                  date < form.getFieldValue("lastActivityDateFrom"))
              }
            />
          </Form.Item>
        </Form.Item>
        <Form.Item label="Customer email" name="customerEmail">
          <Input
            onBlur={handleBlur}
            placeholder="Please enter customer email"
            allowClear
            style={{ width: "314px" }}
          />
        </Form.Item>
      </Space>

      <Space direction="vertical" align="end" size={24}>
        <Form.Item label="Course" name="courseName">
          <Input
            onBlur={handleBlur}
            placeholder="Please enter course name"
            allowClear
            style={{ width: "314px" }}
          />
        </Form.Item>

        <Form.Item label="Customer name" name="customerName">
          <Input
            onBlur={handleBlur}
            placeholder="Please enter customer name"
            allowClear
            style={{ width: "314px" }}
          />
        </Form.Item>

        <Form.Item label="User status" name="userStatus">
          <Radio.Group onChange={handleBlur} style={{ width: "314px" }}>
            <Radio value="ACTIVE">Active</Radio>
            <Radio value="EXPIRED">Expired</Radio>
          </Radio.Group>
        </Form.Item>
      </Space>

      <Divider />

      <Space className={styles.buttonGroup}>
        <Button type="default" shape="round" onClick={toggleFilterButton}>
          Cancel
        </Button>
        <Button type="default" shape="round" onClick={handleReset}>
          Reset
        </Button>
        <Button type="primary" shape="round" htmlType="submit">
          OK
        </Button>
      </Space>
    </Form>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottom"
      visible={open}
      overlayClassName={styles.popover}
      onVisibleChange={toggleFilterButton}
    >
      <Button type="default" shape="round">
        Filter
        <Icon component={DropDown} />
      </Button>
    </Popover>
  );
}

export default UserListFilter;
